import { useCallback, useContext } from 'react'

import { GlobalStoreContext } from '~/contexts/GlobalStoreContext'
import { GlobalStoreProps } from '~/contexts/GlobalStoreReducer'
import type { FormTypes } from '~/data/forms/shared/interfaces/Form'
import { useFeatureFlag } from '~/hooks/useFeatureFlag'

import type { MAB100CollectionCardItemProps } from '../MAB100CollectionCard/MAB100CollectionCard'

const useHooks = () => {
  const { getModalDialogFlag } = useFeatureFlag()
  const modalDialogFlag = getModalDialogFlag()
  const { stateDispatch } = useContext(GlobalStoreContext)

  const openForm = useCallback(
    (formType: FormTypes, item: MAB100CollectionCardItemProps) => {
      stateDispatch({
        type: GlobalStoreProps.UPDATE_MODAL_STATE,
        payload: {
          isOpen: true,
          content: formType,
          isDrawer: modalDialogFlag !== 'control',
          props: {
            isReducedWidth: true,
            artworkId: item.artworkId,
            heroProps: {
              artist: {
                name: item.artist,
                id: item.heroProps.artist.id,
              },
              title: item.title,
              image: item.image.asset,
              sellTicketsCount: item.sellTicketsCount,
              ownedTicketsCount: item.ownedTicketsCount,
              buyTicketsCount: item.buyTicketsCount,
            },
          },
        },
      })
    },
    []
  )

  return {
    openForm,
  }
}

export default useHooks
